import { NEventable } from './NEventable'

export class NPopupConfig extends NEventable {
    constructor (options) {
        super(['open', 'close'])

        options = options || {}

        this.direction = options.direction !== undefined && options.direction !== null
            ? options.direction
            : 'se'

        if (!['n', 'ne', 'e', 'se', 's', 'sw', 'w', 'nw'].includes(this.direction)) {
            // eslint-disable-next-line no-console
            console.warn(
                'NPopupConfig: invalid value (%s) specified for `direction`, defaulting to: `se`',
                options.direction
            )
            this.direction = 'se'
        }

        this.origin = options.origin !== undefined && options.origin !== null
            ? options.origin
            : 'reference'

        if (!['reference', 'mouse'].includes(this.origin)) {
            // eslint-disable-next-line no-console
            console.warn(
                'NPopupConfig: invalid value (%s) specified for `origin`, defaulting to: `reference`',
                options.origin
            )
            this.origin = 'reference'
        }

        this.mode = options.mode !== undefined && options.mode !== null
            ? options.mode
            : 'click'

        if (!['click', 'hover', 'manual'].includes(this.mode)) {
            // eslint-disable-next-line no-console
            console.warn(
                'NPopupConfig: invalid value (%s) specified for `mode`, defaulting to: `click`',
                options.mode
            )
            this.mode = 'click'
        }

        this.fixed = options.fixed !== undefined && options.fixed !== null
            ? options.fixed
            : false

        if (typeof this.fixed !== 'boolean') {
            // eslint-disable-next-line no-console
            console.warn(
                'NPopupConfig: invalid value (%s) specified for `fixed`, defaulting to: false',
                options.fixed
            )
            this.fixed = false
        }

        this.autoClose = options.autoClose !== undefined && options.autoClose !== null
            ? options.autoClose
            : true

        if (typeof this.autoClose !== 'boolean') {
            // eslint-disable-next-line no-console
            console.warn(
                'NPopupConfig: invalid value (%s) specified for `autoClose`, defaulting to: true',
                options.autoClose
            )
            this.autoClose = true
        }

        this.offsetSkidding = options.offsetSkidding !== undefined && options.offsetSkidding !== null
            ? options.offsetSkidding
            : 0

        if (!Number.isFinite(this.offsetSkidding)) {
            // eslint-disable-next-line no-console
            console.warn(
                'NPopupConfig: invalid value (%s) specified for `offsetSkidding`, defaulting to: 0',
                options.offsetSkidding
            )
            this.offsetSkidding = 0
        }

        this.offsetDistance = options.offsetDistance !== undefined && options.offsetDistance !== null
            ? options.offsetDistance
            : 0

        if (!Number.isFinite(this.offsetDistance)) {
            // eslint-disable-next-line no-console
            console.warn(
                'NPopupConfig: invalid value (%s) specified for `offsetDistance`, defaulting to: 0',
                options.offsetDistance
            )
            this.offsetDistance = 0
        }

        this.maxWidth = 350

        if (options.maxWidth !== undefined) {
            this.maxWidth = options.maxWidth
        }

        if (!Number.isFinite(this.maxWidth) && this.maxWidth !== null) {
            // eslint-disable-next-line no-console
            console.warn(
                'NPopupConfig: invalid value (%s) specified for `maxWidth`, defaulting to: 350',
                options.maxWidth
            )
            this.maxWidth = 350
        }

        this.duration = options.duration !== undefined && options.duration !== null
            ? options.duration
            : 0

        if (
            !Number.isFinite(this.duration) &&
            !(
                Array.isArray(this.duration) &&
                this.duration.length > 1 &&
                Number.isFinite(this.duration[0]) &&
                Number.isFinite(this.duration[1])
            )
        ) {
            // eslint-disable-next-line no-console
            console.warn(
                'NPopupConfig: invalid value (%s) specified for `duration`, defaulting to: 0',
                options.duration
            )
            this.duration = 0
        }

        this._component = null
    }

    open () {
        if (this._component) {
            this._component.open()
        }
    }

    close () {
        if (this._component) {
            this._component.close()
        }
    }

    get isOpen () {
        return this._component !== null &&
            this._component.tippy !== null &&
            this._component.tippy.state.isShown
    }
}



// WEBPACK FOOTER //
// ./src/components/shared/npopup/NPopupConfig.js